const getTrancatableText = (
  text: string,
  shouldTextTruncate: boolean,
  length = 2
): string => {
  if (shouldTextTruncate && text.length > length) {
    return `${text.slice(0, length)}...`;
  }

  return text;
};

export default getTrancatableText;
